//储值管理路由文件
export default [
  {
    //制卡
    path: '/fabricationManage',
    component: resolve => require(['../pages/storedValue/fabricationManage/fabricationManage.vue'], resolve),
    name: 'fabricationManage',
    title: "制卡",
    meta: {
      title: "制卡"
    }
  },
  {
    //卡生产记录
    path: '/cardRecord',
    component: resolve => require(['../pages/storedValue/cardRecord/cardRecord.vue'], resolve),
    name: 'cardRecord',
    title: '卡生产记录',
    meta: {
      title: "卡生产记录"
    }
  },
  {
    //会员卡管理
    path: '/cardManage',
    component: resolve => require(['../pages/storedValue/cardManage/cardManage.vue'], resolve),
    name: 'cardManage',
    title: "会员卡管理",
    meta: {
      title: "会员卡管理"
    }
  },
  {
    //营销效益卡发放
    path: '/marketingCard',
    component: resolve => require(['../pages/storedValue/marketingCard/marketingCard.vue'], resolve),
    name: 'marketingCard',
    title: "营销效益卡发放",
    meta: {
      title: "营销效益卡发放"
    }
  },
  {
    //交易查询
    path: '/tradingRecord',
    component: resolve => require(['../pages/storedValue/tradingRecord/tradingRecord.vue'], resolve),
    name: 'tradingRecord',
    title: "交易查询",
    meta: {
      title: "交易查询"
    }
  },
  {
    //调账管理
    path: '/accountManage',
    component: resolve => require(['../pages/storedValue/accountManage/accountManage.vue'], resolve),
    name: 'accountManage',
    title: "调账管理",
    meta: {
      title: "调账管理"
    }
  },
  {
    //钱包管理
    path: '/walletManage',
    component: resolve => require(['../pages/storedValue/walletManage/walletManage.vue'], resolve),
    name: 'walletManage',
    title: "钱包管理",
    meta: {
      title: "钱包管理"
    }
  }
]
